import React from 'react';
import { motion } from 'framer-motion';
import { BrainCircuit, BookOpen, Users, LifeBuoy } from 'lucide-react';
export function Solution() {
  const features = [{
    icon: <BrainCircuit size={28} className="text-link-blue" data-id="element-231" />,
    title: 'Alice App',
    text: 'Nuestra herramienta de IA que genera estrategias de marketing digital en minutos según tu negocio, tu audiencia y tu objetivo.'
  }, {
    icon: <BookOpen size={28} className="text-link-blue" data-id="element-232" />,
    title: 'Cursos prácticos',
    text: 'Aprende desde cero hasta crear campañas, embudos, automatizaciones y procesos reales.'
  }, {
    icon: <Users size={28} className="text-link-blue" data-id="element-233" />,
    title: 'Comunidad en Skool',
    text: 'Conecta con personas que también están aprendiendo, ejecutando y construyendo su camino digital.'
  }, {
    icon: <LifeBuoy size={28} className="text-link-blue" data-id="element-234" />,
    title: 'Mentorías y soporte',
    text: 'Recibe guía, respuestas y dirección para no quedarte bloqueado cuando llega el momento de aplicar.'
  }];
  return <section id="como-funciona" className="py-12 lg:py-16 bg-white" data-id="element-235">
      <div className="container mx-auto px-4 md:px-6" data-id="element-236">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-237">
          <h2 className="text-3xl md:text-4xl font-bold text-link-dark mb-6" data-id="element-238">
            Todo lo que necesitas para avanzar en marketing digital, en un solo
            lugar
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-239">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex gap-6 p-8 rounded-3xl bg-white border border-gray-100 shadow-sm hover:shadow-md hover:border-link-light transition-all group" data-id="element-240">
              <div className="flex-shrink-0 w-14 h-14 rounded-2xl bg-link-light flex items-center justify-center group-hover:scale-110 transition-transform duration-300" data-id="element-241">
                {feature.icon}
              </div>
              <div data-id="element-242">
                <h3 className="text-xl font-bold text-link-dark mb-3" data-id="element-243">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-244">{feature.text}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}